export const reactQuizQuestions = [
  {
    question: "What is React?",
    options: [
      "A JavaScript library for building user interfaces",
      "A programming language",
      "A database management system",
      "An operating system",
    ],
    correctOption: 0,
    points: 10,
  },
  {
    question: "In JSX, what does the expression { } represent?",
    options: [
      "A JavaScript comment",
      "An object literal",
      "A JavaScript function call",
      "A JavaScript expression or variable",
    ],
    correctOption: 3,
    points: 20,
  },
  {
    question: "What is the purpose of state in React?",
    options: [
      "To store data that can be changed over time",
      "To declare a constant variable",
      "To perform mathematical calculations",
      "To create global variables",
    ],
    correctOption: 0,
    points: 40,
  },
  {
    question: "What is a functional component in React?",
    options: [
      "A component with a state",
      "A component that uses a class",
      "A component without state or lifecycle methods",
      "A component with multiple render methods",
    ],
    correctOption: 2,
    points: 10,
  },
  {
    question: "What is the virtual DOM in React?",
    options: [
      "A backup DOM",
      "A lightweight copy of the DOM",
      "An alternative to the actual DOM",
      "A separate DOM for mobile devices",
    ],
    correctOption: 1,
    points: 20,
  },
  {
    question:
      "How can you pass data from a parent component to a child component in React?",
    options: ["Using props", "Using state", "Using Redux", "Using context"],
    correctOption: 0,
    points: 40,
  },
  {
    question: "What is React Router used for?",
    options: [
      "Form validation",
      "State management",
      "Navigating between different views in a React application",
      "Data fetching",
    ],
    correctOption: 2,
    points: 10,
  },
  {
    question: "What is the purpose of the useEffect hook in React?",
    options: [
      "To handle events",
      "To perform side effects in functional components",
      "To manage state in class components",
      "To declare variables",
    ],
    correctOption: 1,
    points: 20,
  },
  {
    question: "What is Redux in React?",
    options: [
      "A state management library",
      "A CSS-in-JS library",
      "A testing framework",
      "A build tool",
    ],
    correctOption: 0,
    points: 40,
  },
  {
    question: "What is the role of the render() method in React?",
    options: [
      "To render the component's UI",
      "To update the component's state",
      "To handle user input",
      "To manage asynchronous operations",
    ],
    correctOption: 0,
    points: 10,
  },
  {
    question: "What is the purpose of the useRef hook in React?",
    options: [
      "To fetch data from an API",
      "To create a reference to a DOM element",
      "To manage component state",
      "To create global variables",
    ],
    correctOption: 1,
    points: 20,
  },
  {
    question: "What is the purpose of the useMemo hook in React?",
    options: [
      "To memoize functions",
      "To create reusable components",
      "To manage side effects",
      "To handle keyboard events",
    ],
    correctOption: 0,
    points: 40,
  },
  {
    question: "What is React Native used for?",
    options: [
      "Web development",
      "Mobile app development",
      "Database management",
      "Machine learning",
    ],
    correctOption: 1,
    points: 10,
  },
  {
    question: "What is the significance of keys in React lists?",
    options: [
      "To improve performance",
      "To uniquely identify elements in a list",
      "To style list items",
      "To define event handlers",
    ],
    correctOption: 1,
    points: 20,
  },
  {
    question: "How can you handle forms in React?",
    options: [
      "Using the submit() method",
      "Using the form() function",
      "Using controlled components and state",
      "Using inline styles",
    ],
    correctOption: 2,
    points: 40,
  },
];

// Add more questions to complete the array with a total of 15 questions

// Add more questions to complete the array with a total of 15 questions
